import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { ResponsiveBar } from "@nivo/bar"; // CAMBIO
import Header from "../../components/Header";
import { getStock2TejidoStock } from "../../services/stockTejido.services";
import useMediaQuery from "@mui/material/useMediaQuery";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { DataGrid } from "@mui/x-data-grid";
import { useTheme } from "@mui/material/styles";
import { tokens } from "../../theme"; 

const ProduccionFuncTejido = () => {
  const [data, setData] = useState([]);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [totalProduccion, setTotalProduccion] = useState(0);
  const meta = 4001;
  const [fechaInicio, setFechaInicio] = useState(dayjs().startOf("day"));
  const [fechaFin, setFechaFin] = useState(dayjs().endOf("day"));
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  useEffect(() => {
    const fetchStock = async () => {
      try {
        const stock = await getStock2TejidoStock();

        const filtradoPorRango = stock.filter((item) => {
          const fechaItem = dayjs(item.create_at);
          return fechaItem.isAfter(fechaInicio) && fechaItem.isBefore(fechaFin);
        });

        const conteo = {};

        filtradoPorRango.forEach((item) => {
          const operador = item.operador;
          const maquina = item.maquina_descripcion || "N/A"; // o como venga
          const metrosCuadrados = (item.mcuadradototal) || 0;
          if (!conteo[operador]) {
            conteo[operador] = { operador, maquina, produccion: metrosCuadrados };
          } else {
            conteo[operador].produccion += metrosCuadrados;
          }
        });

        const parsedData = Object.values(conteo)
          .map((item) => ({
            ...item,
            meta,
            estado: item.produccion >= meta ? "Alcanzado" : "No alcanzado",
          }))
          .sort((a, b) => a.produccion - b.produccion);
        
        setData(parsedData);

      } catch (error) {
        console.error("Error al obtener el stock de tejido:", error);
      }
    };

    fetchStock();
  }, [fechaInicio, fechaFin]);

  return (
    <Box
      m="20px"
      sx={{
        height: "85vh",
        overflow: "auto",
        padding: "10px",
        width: "97%",
        // boxSizing: "border-box"
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          paddingRight: "50px",
        }}
      >
        <Header title="Estadísticas" subtitle="Producción por funcionario" />
        <Box
          display="flex"
          justifyContent="center"
          sx={{
            marginRight: "2%",
            marginLeft: "2%",
            marginTop: "1.2vh",
            "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
          }}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box display="flex" justifyContent="end" gap={4} mb={4}>
              <DatePicker
                label="Desde"
                value={fechaInicio}
                onChange={(newValue) => setFechaInicio(newValue)}
              />
              <DatePicker
                label="Hasta"
                value={fechaFin}
                onChange={(newValue) => setFechaFin(newValue)}
              />
            </Box>
          </LocalizationProvider>
        </Box>
      </Box>

      <Box justifyContent="center" mb={2} sx={{ 
        width:"100%"
      }}>
        <Box width="100%" height="20%">
          <Box display="flex" justifyContent="flex-end" mb={2}>
            <Box sx={{ color: "#fff", fontSize: 18, paddingRight:"5vw"}}>
              Meta de Producción: {meta} m²
            </Box>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          width: "100%",
          height: "80%",
        }}
      >
        <ResponsiveBar
          data={data}
          keys={["produccion"]}
          layout="horizontal"
          indexBy="operador"
          colorBy="indexValue"
          margin={{ top: 50, right: 5, bottom: 80, left: 120 }}
          padding={0.3}
          colors={{ scheme: "set2" }}
          borderColor={{ from: "color", modifiers: [["darker", 1.6]] }}
          axisTop={null}
          axisRight={null}
          axisBottom={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legendPosition: "middle",
            legendOffset: 32,
          }}
          axisLeft={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legendPosition: "middle",
            legendOffset: -40,
          }}
          labelSkipWidth={12}
          labelSkipHeight={12}
          labelTextColor={{ from: "color", modifiers: [["darker", 1.6]] }}
          tooltip={({ id, value, color }) => (
            <div
              style={{
                padding: "6px 12px",
                background: color,
                color: "#fff",
                borderRadius: "4px",
                fontSize: "20px",
              }}
            >
              <strong>{id}:</strong> {value} m²
            </div>
          )}
          theme={{
            axis: {
              ticks: {
                text: {
                  fill: "#ffffff",
                },
              },
              legend: {
                text: {
                  fill: "#ffffff",
                },
              },
            },
            legends: {
              text: {
                fill: "#ffffff",
              },
            },
            tooltip: {
              container: {
                background: "#333",
              },
            },
          }}
          animate={true}
        />
        <Box mt={4}
    height="70vh" width="100%"
    sx={{
      "& .MuiDataGrid-root": {
        border: "none",
      },
      "& .MuiDataGrid-cell": {
        borderBottom: "none",
      },
      "& .name-column--cell": {
        color: colors.greenAccent?.[300] || "#66bb6a",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: colors.blueAccent?.[900] || "#1565c0",
        borderBottom: "none",
      },
      "& .MuiDataGrid-virtualScroller": {
        backgroundColor: colors.primary?.[400] || "#1e1e2f",
      },
      "& .MuiDataGrid-footerContainer": {
        borderTop: "none",
        backgroundColor: colors.blueAccent?.[900] || "#1565c0",
      },
      "& .MuiCheckbox-root": {
        color: `${colors.greenAccent?.[200] || "#a5d6a7"} !important`,
      },
      "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
        color: `${colors.grey?.[100] || "#ffffff"} !important`,
      },
    }}>
          <DataGrid
            rows={data.map((item, index) => ({ id: index, ...item }))}
            columns={[
              { field: "operador", headerName: "Funcionario", flex: 1 },
              { field: "maquina", headerName: "Máquina", flex: 1 },
              { field: "produccion", headerName: "Producción", type: "number", flex: 1 },
              { field: "meta", headerName: "Meta", type: "number", flex: 1 },
              {
                field: "estado",
                headerName: "Estado",
                flex: 1,
                renderCell: (params) => (
                  <span
                    style={{
                      color: params.value === "Alcanzado" ? "rgb(206, 220, 0)" : "red",
                      fontWeight: "bold",
                    }}
                  >
                    {params.value}
                  </span>
                ),
              },
            ]}
            disableRowSelectionOnClick
            initialState={{
              pagination: { paginationModel: { pageSize: 5 } },
            }}
            pageSizeOptions={[5, 10, 20]}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default ProduccionFuncTejido;
